import { Route } from 'react-router-dom';
import PreparationParrainagePotentiel from './PreparationParrainagePotentiel';
/**
 * Routes configurées pour le module ParrainageView
 */
const PreparationParrainagePotentielViewRoutes = [
    <Route
        key="parrainage-view-main-data-parrainages"
        path="preparationParrainagePotentiel"
        element={<PreparationParrainagePotentiel />}
    />,
];

export default PreparationParrainagePotentielViewRoutes;


